var parsePriceFilter = function parsePriceFilter(price) {
  var priceValue = Number(price) / 100;
  return Math.round(priceValue * 1000) / 1000;
};
export default parsePriceFilter;